import { config } from 'state/attribute/config'
import { Color } from 'state/color'
import 'state/attribute/events/toggle'

export class Attribute {
  constructor(attribute, group) {
    Object.assign(this, {
      alias: attribute.alias,
      id: `${attribute.id}`,
      // is: {
      //   active: true,
      //   selected: false
      // },
      class: config.classes.default,
      counts: {
        bySKU: attribute.counts.bySKU,
        byID: attribute.counts.byID
      },
      defaultCount: attribute.count,
      group: group,
      name: attribute.name,
      nameLeftNav: attribute.nameLeftNav,
      path: attribute.path,
      products: {},
      sortOrder: attribute.sortOrder,
      url: attribute.url
    })

    this.nodes = {
      container: document.createElement('li'),
      link: document.createElement('a')
    }

    let colors = Color.by.attribute[attribute.id] ? Object.values(Color.by.attribute[attribute.id]) : []

    this.aliases = new Set([...colors.map(color => color.alias)])
    this.colors = new Set([...colors.map(color => color.colormap)])
    this.productIDs = new Set([...colors.map(color => color.productID)])

    this.count = Color.display.by.id ? this.productIDs.size : this.aliases.size
    this.is = {
      active: MK.page.nameLeftNav === this.nameLeftNav || this.count > 0,
      selected: false
    }

    if (MK.page.nameLeftNav === this.nameLeftNav) {
      group.is.abbreviated = false
    }

    group.attributes.push(this)
  }
}

Attribute.prototype = {
  clearSelections: function () {
    Object.assign(this, {
      activeCounts: null,
      class: config.classes.default,
      count: (Color.display.by.id ? this.productIDs.size : this.aliases.size),
      // count: this.defaultCount,
      is: {
        active: true,
        selected: false
      }
    })

    this.checkForRedirects()
    // Object.assign(this, { is: { active: true, selected: false }, class: config.classes.default, count: this.defaultCount })
  },
  updateCount(active) {
    // if (Color.display.by.id) {
    if (active.productIDs.size > 0 && active.aliases.size > 0) {
      this.activeCounts = {
        aliases: active.aliases.size,
        colors: active.colors.size,
        productIDs: active.productIDs.size
      }
      this.count = Color.display.by.id ? active.productIDs.size : active.aliases.size
      this.active = this.count > 0
    } else {
      this.activeCounts = {
        aliases: 0,
        colors: 0,
        productIDs: 0
      }
      this.count = 0
      this.active = false
    }
    // }
    // this.syncWithDOM()
  },
  isActive() {
    return this.is.selected || this.count > 0
  },
  checkForRedirects() {
    if (!this.is.selected && MK.page.type === 'attribute' && this.nameLeftNav === MK.page.nameLeftNav) {
      const pathname = MK.page.url.parent
      MK.events.emit('redirect', {
        pathname
      })
    }
  },
  syncWithDOM(parentNode) {
    this.is.active = this.is.selected || this.count > 0
    this.calculateClass()

    if (this.is.active) {
      this.parentNode = this.parentNode || parentNode

      this.nodes = {
        container: document.createElement('li'),
        link: document.createElement('a')
      }

      // Determine active class
      this.calculateClass()

      // Update class name to active class
      this.nodes.container.className = this.class

      this.nodes.link.attribute = this
      this.nodes.link.href = this.url
      this.nodes.link.title = this.name

      this.nodes.link.setAttribute('data-count', `${this.count}`)

      this.nodes.link.innerHTML = `${this.nameLeftNav} `
      this.nodes.container.appendChild(this.nodes.link)
      this.parentNode.appendChild(this.nodes.container)
    }
  },
  calculateClass: function () {
    // Attribute is active if selected, even with no products available for display/refinement.
    this.class = this.is.selected ? config.classes.selected : config.classes.default
  }
}

Attribute.selections = {
  container: document.getElementById('active-refinements'),
  nodes: []
}

Attribute.thresholds = config.thresholds
Attribute.index = {}
